import { IOperatorIncome } from "@interfaces/admin/operatorIncome";
import { KyivstarSvg, LifecellSvg, VodafoneSvg } from "../../svg";
import style from "./OperatorIncome.module.scss";
import cn from "classnames";
import { EOperator } from "@interfaces/operator.enum";

export function OperatorIncome({
    data
}: {
    data: IOperatorIncome
}) {
    return (
        <div className={style.container}>
            <div className={style.header}>
                <div className="w-[20%] h-full bg-[#FFFFFF] rounded-ss-[25px] rounded-se-[8px]"></div>
                <div className="w-[60%] h-full bg-[#F3F4F8] p-[12px] pt-0 rounded-[10px]">
                    <div className="flex h-full justify-center items-center gap-[10px] bg-[#FFFFFF] rounded-[8px]">
                        {
                            {
                                [EOperator.Kyivstar.toLocaleLowerCase()]: <KyivstarSvg />,
                                [EOperator.Vodafone.toLocaleLowerCase()]: <VodafoneSvg />,
                                [EOperator.lifecell.toLocaleLowerCase()]: <LifecellSvg />,
                            }[data.operator.toLocaleLowerCase()]
                        }
                        <p className={style.name}>{data.operator}</p>
                    </div>
                </div>
                <div className="w-[20%] h-full bg-[#FFFFFF] rounded-ss-[8px] rounded-se-[25px]"></div>
            </div>
            <div className={style.body}>
                <div className={style.list}>
                    {
                        [...data.periods].sort((a, b) => a.days - b.days).map((item, i) => (
                            <div key={i} className={style.parameter}>
                                <div className="flex w-1/2 justify-between">
                                    <p>{getDayString(item.days)}:</p>
                                    <p className={style.value}>{item.purchase_count}</p>
                                </div>
                                <div className={style.divider}></div>
                                <div className="flex w-1/2">
                                    <p className={style.value}>$ {item.total_sum}</p>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

function getDayString(n: number): string {
    if (!Number.isInteger(n) || n < 0) {
        return `${n} днів`;
    }
    
    const lastDigit = n % 10;
    const lastTwoDigits = n % 100;
    
    if (lastTwoDigits >= 11 && lastTwoDigits <= 19) {
        return `${n} днів`;
    }
    
    if (lastDigit === 1) {
        return `${n} день`;
    }
    
    if (lastDigit >= 2 && lastDigit <= 4) {
        return `${n} дня`;
    }
    
    return `${n} днів`;
}